// src/context/ColorModeContext.tsx
import React from 'react';

interface ColorModeContextType {
  toggleColorMode: () => void;
}

const ColorModeContext = React.createContext<ColorModeContextType>({
  toggleColorMode: () => {
    // Do nothing
  },
});

export default ColorModeContext;
